import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TableRowSelectEvent } from 'primeng/table';

import { LoteImportacaoBanco } from '../../models/lote-importacao-banco';
import { DesfazerImportacaoApiService } from '../../services/desfazer-importacao-api.service';

@Component({
  selector: 'app-escolher-lote-importacao-dialog',
  standalone: false,
  templateUrl: './escolher-lote-importacao-dialog.component.html',
  styleUrl: './escolher-lote-importacao-dialog.component.scss'
})
export class EscolherLoteImportacaoDialogComponent implements OnInit {

  contaBancoId: number;

  lotes: LoteImportacaoBanco[] = [];

  constructor(
    private desfazerImportacaoApiService: DesfazerImportacaoApiService,
    private dialogRef: MatDialogRef<EscolherLoteImportacaoDialogComponent>
  ) { }

  ngOnInit(): void {
    this.desfazerImportacaoApiService.listarLotesImportacaoCartao(this.contaBancoId)
      .subscribe(lotes => {
        lotes.forEach(lote => {
          lote.dataCadastroFormatada = new Date(lote.dataCadastro).toLocaleString('pt-BR');
          lote.periodoFormatado = `${new Date(lote.dataInicial).toLocaleDateString('pt-BR')} a ${new Date(lote.dataFinal).toLocaleDateString('pt-BR')}`;
        });
        this.lotes = lotes;
      });
  }

  public onLoteSelect(event: TableRowSelectEvent<LoteImportacaoBanco>): void {
    const lote = event.data as LoteImportacaoBanco | undefined;
    if (!lote) return;

    this.dialogRef.close(lote.id);
  }
}
